import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithInterceptor } from "src/utils/baseQuery";

export const UserApi = createApi({
  reducerPath: "UserApi",
  baseQuery: baseQueryWithInterceptor,
  tagTypes: ["User"],
  endpoints: (builder) => ({
    getUsers: builder.query<any, { page?: number; limit?: number }>({
      query: ({ page = 1, limit = 10 } = {}) => ({
        url: `user?type=enforcement&type=vendor`,
        method: "GET",
        headers: {
          "Content-type": "application/json",
        },
        params: { page, limit },
      }),
    }),
    searchUserByEmail: builder.query<any, string>({
      query: (email) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `user?email=${email}`,
        method: "GET",
      }),
    }),
    getShipperById: builder.query<any, string>({
      query: (id) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `user/search?type=shipper&_id=${id}`,
        method: "GET",
      }),
    }),
    getDriverById: builder.query<any, string>({
      query: (id) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `user/search?type=driver&_id=${id}`,
        method: "GET",
      }),
    }),
    fetchDriverById: builder.mutation<any, string>({
      query: (id) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `user/search?type=driver&_id=${id}`,
        method: "GET",
      }),
    }),
    getDriverByDlNumber: builder.query<any, any>({
      query: ({id, company}) => ({
        headers: {
          "Content-type": "application/json",
        },
        // url: `user/driver?driver=${id}&company=${company}`,
        url: `user/driver?driver=${id}`,
        method: "GET",
      }),
    }),

    getUserByDlNumber: builder.mutation<any, any>({
      query: ({dlNumber}) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `user/search?type=driver&dlNumber=${dlNumber}`,
        method: "GET",
      }),
    }),

    getTransporter: builder.query<any, void>({
      query: () => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `user/search?type=transporter`,
        method: "GET",
      }),
    }),
    getVehicleByNumber: builder.query<any, any>({
      query: ({id, vehicleNumber}) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `vehicle/search?vehicle=${vehicleNumber}`,
        method: "GET",
      }),
    }),
    getTrailerByNumber: builder.query<any, any>({
      query: ({id, trailerNumber}) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `trailer?number=${trailerNumber}`,
        method: "GET",
      }),
    }),
    getUserProfile: builder.mutation<any, void>({
      query: () => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `user/profile`,
        method: "GET",
      }),
    }),
    fetchCompanyList: builder.query<any, { page?: number; limit?: number }>({
      query: (queryParams) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `company/`,
        method: "GET",
        query: queryParams,
      }),
    }),

    getUserProfileData: builder.query<any, void>({
      query: () => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `user/profile`,
        method: "GET",
      }),
    }),
    patchUserProfileData: builder.mutation<any, any>({
      query: (data) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `user`,
        method: "PATCH",
        body: data,
      }),
    }),
    inviteUser: builder.mutation<any, any>({
      query: (data) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `user/`,
        method: "POST",
        body: data,
      }),
    }),
    patchUser: builder.mutation<any, any>({
      query: ({id,data}) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `user/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),

    updateCompanyById: builder.mutation<any, any>({
      query: ({id,data}) => ({
        url: `company/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),

    getCompanyById: builder.query<any, string>({
      query: (id) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `company/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetUsersQuery,
  useSearchUserByEmailQuery,
  useGetShipperByIdQuery,
  useGetDriverByIdQuery,
  useGetVehicleByNumberQuery,
  useGetTrailerByNumberQuery,
  useGetTransporterQuery,
  useFetchDriverByIdMutation,
  useGetDriverByDlNumberQuery,
  useGetUserProfileMutation,
  useFetchCompanyListQuery,
  useGetUserProfileDataQuery,
  usePatchUserProfileDataMutation,
  useInviteUserMutation,
  usePatchUserMutation,
  useGetUserByDlNumberMutation,

  useGetCompanyByIdQuery,
  useUpdateCompanyByIdMutation
} = UserApi;
